import React from "react"
import { FormattedMessage } from "react-intl"
import Tabs from "../../common/layout/tabs.component"

type OwnProps = {
    locationId: string
}

const LocationEditTabs = (props: OwnProps) => {

    const detailsLink = `/locations/${props.locationId}/edit`
    const templateSettingsLink = `/locations/template-settings/edit/${props.locationId}`
    const tabs = [
        {
            name: <FormattedMessage
                id="user_edit.tabs.my_account.details"
                defaultMessage="Details"
            />,
            link: detailsLink,
        },
        {
            name: <FormattedMessage
                id="location_edit.tabs.template_settings"
                defaultMessage="Template Settings"
            />,
            link: templateSettingsLink,
        },
    ]
    return (
        <Tabs
            value={tabs}
        />

    )

}

export default LocationEditTabs


// WEBPACK FOOTER //
// ./src/location/form/LocationTabsComponent.tsx